export const quickLinks = [
  {
    title: 'training.nav.trainingAccount',
    route: '/fortbildung/cycle',
    permission: 'general',
    visible: () => true
  }
]
